import useReactHookForm from "hooks/useReactHookForm";

import { useAppDispatch, useAppSelector } from "hooks/redux";
import { Button, Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import {
  subjectInitialValues,
  subjectMandatoryFields,
  subjectProperties,
  subjectValidationSchema,
} from "./helper";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { useMutation } from "@apollo/client";
import entitesClient from "utils/graphql/entitiesClient";
import { CREATE_YEAR } from "utils/graphql/services/entities/mutations";
import { isEmpty } from "utils/helpers";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import { useHistory } from "react-router-dom";
import { isFieldsValidate } from "shared/organisms/dynamicform/helper";
import LoadingButton from "@mui/lab/LoadingButton";
import { metadataSuccess } from "app-component/slices/metadata-slice";
import { getAcademicYearListData } from "utils/metadata-split/metaDataApiFetch";
import { CREATE_SUBJECT } from "utils/graphql/services/global-content-hierarchy/mutation";
import { shouldDisableButton } from "pages/global-content-hierarchy/helper";
import { useRef, useState } from "react";
import JSONInput from "react-json-editor-ajrm";
import locale from "react-json-editor-ajrm/locale/en";
import axios from "axios";
import JsonEditorStorage from "./components/json-editor";

export const SubjectCreate = () => {
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    subjectInitialValues,
    subjectValidationSchema,
    ""
  );
  const [createSubject, { loading, error, data }] = useMutation(
    CREATE_SUBJECT,
    {
      client: entitesClient,
    }
  );
  const dispatch = useAppDispatch();
  const history = useHistory();
    const [assests, setAssestsData] = useState({});
    const [tags, setTagsData] = useState({});
    const [jsonData, setJsonData] = useState({});
  const [isJsonValid, setIsJsonValid] = useState(true);

  const { isLoading, data: metaData }: any = useAppSelector(
    (state) => state.metadataReducer
  );

   const handleJsonChange = (value: unknown, isValid: boolean) => {
    setJsonData(value || {});
    setIsJsonValid(isValid);
  };

  const handleCreateSubject = async () => {
    let obj = {};
    try {
      const response: any = await createSubject({
        variables: {
          input: {
            global_name: watch()?.global_name,
            status: watch()?.status,
            subject_code: watch()?.subject_code,
            image_url: watch()?.image_url,
            tags: tags,
            synonyms: watch()?.synonyms,
            sbd_subject_id: watch()?.sbd_subject_id,
            assets: assests,
          },
        },
      });
      if (!isEmpty(response?.data?.createSubject?.success)) {
        dispatch(
          snackbarRequest({
            message:
              `${response?.data?.createSubject?.message}` ||
              `Created Subject successfully`,
          })
        );
        history.replace(`/global-content-hierarchy/subjects`);
      } else {
        dispatch(
          snackbarRequest({
            message: `${response?.message}` || `failed to create subject`,
            type: "error",
          })
        );
      }
    } catch (err: any) {
      dispatch(
        snackbarRequest({
          message: `${err}` || `failed to create subject`,
          type: "error",
        })
      );
    }
  };
console.log("hemanth assests",assests)
  return (
    <div>
      <TypographyHeading>Create Subject</TypographyHeading>
      <Paper elevation={2} sx={{ px: 2, pb: 2, pt: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={subjectProperties}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
          <ContentRight sx={{ mt: -7 }}>
            <LoadingButton
              variant="contained"
              loadingPosition="start"
              sx={{
                width: "200px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 23.5px 7px 23.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleCreateSubject}
              disabled={shouldDisableButton(watch(), ["global_name"])}
              loading={loading}
            >
              Create Subject
            </LoadingButton>
          </ContentRight>
        </Grid>
      </Paper>
         <JsonEditorStorage setData={setAssestsData} name={"Assets"} />
         <JsonEditorStorage setData={setTagsData} name={"Tags"} />
    </div>
  );
};
